import React from 'react';
import styled, { css } from 'styled-components';

type Props = {
  children?: React.ReactNode;
};
const BottomButtonRow: React.FCC<Props> = ({ children }) => (
  <ButtonsRow>{children}</ButtonsRow>
);

const ButtonsRow = styled.div<{}>`
  display: flex;
  align-self: flex-end;
  justify-content: space-between;
  min-width: 100%;

  ${({ theme }) => css`
    padding: ${theme.space('s')} ${theme.space('l')};
    background-color: ${theme.color('white', 'dark')};
    border-bottom-left-radius: ${theme.getTokens().border.radius.m};
    border-bottom-right-radius: ${theme.getTokens().border.radius.m};
    margin-top: ${theme.space('m')};

    & > * {
      margin-left: ${theme.space('m')};
    }
  `};
`;

export default BottomButtonRow;
